import { combineReducers } from 'redux';

import * as actions from '../actions';

function byId(state = {}, action) {
  switch (action.type) {
    case actions.REQUEST_QUESTIONNAIRE_SUCCESS:
    case actions.UPDATE_QUESTIONNAIRE_SUCCESS:
    case actions.SEND_QUESTIONNAIRE_SUCCESS:
      return Object.assign({}, state, action.data.response.entities.questionnaireTemplates);
    default:
      return Object.assign({}, state);
  }
}

const questionnaireTemplates = combineReducers({
  byId,
});

export default questionnaireTemplates;

export const getQuestionnaireTemplateById = (state, id) =>
  Object.assign({}, state.questionnaireTemplates.byId[id]);
